import { postAxiosAdminRequest } from "@API";
import { AxiosInstance, AxiosResponse } from "axios";
import { IApp, IGetAxiosApps, IPostAxiosApp, NewAppPayload } from "./types";

export const getAxiosApps = async (): Promise<IGetAxiosApps> => {
  const request: AxiosInstance = postAxiosAdminRequest();
  const response: AxiosResponse = await request.get("/apps");
  const appsData: IApp[] = response.data;
  return { data: appsData };
};

export const postAxiosCreateApp = async (
  payload: NewAppPayload
): Promise<IPostAxiosApp> => {
  const request: AxiosInstance = postAxiosAdminRequest();
  const response: AxiosResponse = await request.post("/apps", payload);
  const newApp: IApp = response.data;
  return { data: newApp };
};

export const getAppPolicyEndpoint = async (
  appId: string,
  type: string
): Promise<AxiosResponse> => {
  const request: AxiosInstance = postAxiosAdminRequest();
  return await request.get(`/policies/${type}`, {
    params: { appId },
  });
};

export const postAppPolicyRequest = async (data: {
  appId: string;
  type: string;
  contentEN: string;
  contentDE: string;
}): Promise<void> => {
  const request: AxiosInstance = postAxiosAdminRequest();
  await request.post(
    "/policies",
    {
      type: data.type,
      contentEN: data.contentEN,
      contentDE: data.contentDE,
    },
    { params: { appId: data.appId } }
  );
};
